export default "__VITE_ASSET__BqDO9NVd__"